import React from 'react'

const COLUMN_COUNTS = {
  active: 6,
  order: 6,
}

const BetRowSkeleton = ({ activeOrPast = 'active', columnCount: columnCountOverride }) => {
  const columnCount = columnCountOverride ?? COLUMN_COUNTS[activeOrPast] ?? 5

  const skeletonCells = Array.from({ length: columnCount }, (_, index) => (
    <td key={index} className="py-4 pr-4">
      {index === 0 ? (
        <div className="flex items-center gap-0">
          <div className="skeleton rounded-[var(--radius-xs)] h-12 w-12 pr-4"></div>
          <div className="skeleton rounded-2xl h-4 w-full max-w-[120px]"></div>
        </div>
      ) : (
        <div className="skeleton rounded-2xl h-4 w-full max-w-[120px]"></div>
      )}
    </td>
  ))

  return <tr>{skeletonCells}</tr>
}

export default BetRowSkeleton
